export enum SortingType {
  none = "",
  recommended = "recommended",
  brandasc = "brand,asc",
  branddesc = "brand,desc",
  priceasc = "price,asc",
  pricedesc = "price,desc",
}
